import { apiSlice } from "../../app/api/apiSlice";
import { CreateNewAddons, CreateNewCategory, CreateNewSize, CreateNewTemperature, UpdateAddOns, UpdateCategory, UpdateNewSize, UpdateTemperature } from "./setupRequestBody";
import { AddOnsData, AddOnsResponse, CategoryData, CategoryResponse, SetupResponse, SizeData, SizesResponse, TemperatureResponse, TemperatureResponseData } from "./setupResponse";

export const setupApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        // Temperatures
        createTemperature: builder.mutation<SetupResponse, CreateNewTemperature>({
            query: (newTemperature) => ({
                url: '/api/tables/product-types',
                method: 'POST',
                body: newTemperature,
            }),
            invalidatesTags: [{ type: 'Temperature', id: 'LIST' }],
        }),
        getTemperatures: builder.query<TemperatureResponseData[], void>({
            query: () => '/api/tables/product-types',
            transformResponse: (response: TemperatureResponse) => response.data,
            transformErrorResponse: (response) => response.data,
            providesTags: [{ type: 'Temperature', id: 'LIST' }],
        }),
        updateTemperature: builder.mutation<SetupResponse, { temperatureId: number, body: UpdateTemperature}>({
            query: ({temperatureId, body}) => ({
                url: `/api/tables/product-types/${temperatureId}`,
                method: 'PUT',
                body,
            }),
            invalidatesTags: (result, error, { temperatureId }) => [
                { type: 'Temperature', id: 'LIST' },
                { type: 'Client', id: 'LIST' },
                { type: 'Temperature', id: temperatureId },
            ],
        }),
        // Addons
        createNewAddons: builder.mutation<SetupResponse, CreateNewAddons>({
            query: (body) => ({
                url: '/api/fnb/addons',
                method: 'POST',
                body,
            }),
            invalidatesTags: [{ type: 'AddOns', id: 'LIST' }],
        }),
        updateAddons: builder.mutation<SetupResponse, { addonsId: number, body: UpdateAddOns}>({
            query: ({addonsId, body}) => ({
                url: `/api/fnb/addons/${addonsId}`,
                method: 'PUT',
                body,
            }),
            invalidatesTags: (result, error, { addonsId }) => [
                { type: 'AddOns', id: 'LIST' },
                { type: 'Client', id: 'LIST' },
                { type: 'AddOns', id: addonsId },
            ],
        }),
        getAddOns: builder.query<AddOnsData[], void>({
            query: () => `/api/fnb/addons`,
            transformResponse: (response: AddOnsResponse) => response.data,
            transformErrorResponse: (response) => response.data,
            providesTags: [{ type: 'AddOns', id: 'LIST' }],
        }),

        // Categories 
        createNewCategory: builder.mutation<SetupResponse, CreateNewCategory>({
            query: (newCategoryForm) => ({
                url: '/api/fnb/categories',
                method: 'POST',
                body: newCategoryForm,
            }),
            invalidatesTags: [{ type: 'Category', id: 'LIST' }],
        }),
        getCategory: builder.query<CategoryData[], void>({
            query: () => '/api/fnb/categories',
            transformResponse: (response: CategoryResponse) => response.data,
            transformErrorResponse: (response) => response.data,
            providesTags: [{ type: 'Category', id: 'LIST' }],
        }),
        updateCategory: builder.mutation<SetupResponse, { categoryId: number, body: UpdateCategory}>({
            query: ({categoryId, body}) => ({
                url: `/api/fnb/categories/${categoryId}`,
                method: 'PUT',
                body,
            }),
            invalidatesTags: (result, error, { categoryId }) => [
                { type: 'Category', id: 'LIST' },
                { type: 'Category', id: categoryId },
            ],
        }),
        // Size
        createNewSize: builder.mutation<SetupResponse, CreateNewSize>({
            query: (newSizeForm) => ({
                url: '/api/tables/sizes',
                method: 'POST',
                body: newSizeForm,
            }),
            invalidatesTags: [{ type: 'Size', id: 'LIST' }],
        }),
        getSizes: builder.query<SizeData[], void>({
            query: () => '/api/tables/sizes',
            transformResponse: (response: SizesResponse) => response.data,
            transformErrorResponse: (response) => response.data,
            providesTags: [{ type: 'Size', id: 'LIST' }],
        }),
        updateSize: builder.mutation<SetupResponse, { sizeId: number, body: UpdateNewSize}>({
            query: ({sizeId, body}) => ({
                url: `/api/tables/sizes/${sizeId}`,
                method: 'PUT',
                body,
            }),
            invalidatesTags: (result, error, { sizeId }) => [
                { type: 'Client', id: 'LIST' },
                { type: 'Size', id: 'LIST' },
                { type: 'Size', id: sizeId },
            ],
        }),
        
    }),
});

export const {
    // Temperature
    useCreateTemperatureMutation,
    useGetTemperaturesQuery,
    useUpdateTemperatureMutation,

    // Addons
    useCreateNewAddonsMutation,
    useUpdateAddonsMutation,
    useGetAddOnsQuery,

    // Category
    useCreateNewCategoryMutation,
    useGetCategoryQuery,
    useUpdateCategoryMutation,

    // Sizes
    useCreateNewSizeMutation,
    useGetSizesQuery,
    useUpdateSizeMutation,
} = setupApiSlice